import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-cf-red text-white text-center py-1 px-4 font-bold text-xs md:text-sm sticky top-0 z-50 shadow-sm" data-id="element-1">
      <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-2">
        <span data-id="element-3">⏳ OFERTA EXPIRA EN:</span>
        <span className="bg-white text-cf-red px-2 py-0.5 rounded font-mono" data-id="element-4">
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
        <span data-id="element-5">| 🔥 SOLO QUEDAN 3 CUPOS</span>
      </div>
    </div>;
}